<template>
  <el-dialog
    title="设置"
    class="musicbox-setting-wrap"
    :visible="true"
    :before-close="close"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
  >
    <el-form ref="form" label-width="auto" :inline="true" :model="model" :rules="rules">
      <el-form-item label="场景设置">
        <div class="item-wrap">
          <el-radio-group v-model="model.scene">
            <el-radio :label="0">工作场景</el-radio>
            <el-radio :label="1">公共场景</el-radio>
          </el-radio-group>
        </div>
        <el-button @click="setScene" :loading="sceneLoading" type="primary">确定</el-button>
      </el-form-item>
      <el-form-item label="待机设置">
        <div class="item-wrap">
          <el-radio-group v-model="model.switchers">
            <el-radio :label="0">待机</el-radio>
            <el-radio :label="127">开机</el-radio>
          </el-radio-group>
          <el-checkbox v-model="model.mobileState">开启4G</el-checkbox>
        </div>
        <el-button @click="setSwitch" :loading="switchLoading" type="primary">确定</el-button>
      </el-form-item>
      <el-form-item label="时间设置">
        <div class="item-wrap">
          <el-date-picker
            v-model="model.date"
            value-format="timestamp"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <el-button @click="setTime" :loading="dateLoading" type="primary">确定</el-button>
      </el-form-item>
      <el-form-item label="发送间隔时间" prop="interval">
        <div class="item-wrap">
          <el-input v-model="model.interval" />
        </div>
        <el-button @click="setInterval" :loading="intervalLoading" type="primary">确定</el-button>
      </el-form-item>
      <el-form-item label="获取设备基本信息">
        <div class="space">(含主板、设备号、配置信息、阈值、阈值缺省值、IP地址等基本信息)</div>
        <el-button @click="getDeviceInfo" :loading="getInfoLoading" type="primary">获取</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  setScene,
  setTime,
  setSwitch,
  getDeviceInfo,
  getDeviceStatus,
  setNotifyInterval
} from '@/api/deviceSetting';

function validator(_, value, callback) {
  if (/^\d+$/.test(value) && value > 0) {
    callback();
  } else {
    callback(new Error('有效值大于0的整数'));
  }
}

const rules = { interval: [{ validator, trigger: 'change' }] };

export default {
  props: {
    sn: String,
    deviceType: String
  },
  data() {
    return {
      model: {
        scene: 1,
        date: Date.now(),
        switchers: 0,
        interval: 0,
        mobileState: false
      },
      loading: true,
      sceneLoading: false,
      switchLoading: false,
      dateLoading: false,
      getInfoLoading: false,
      intervalLoading: false,
      rules
    };
  },
  methods: {
    close() {
      this.destroy();
      this.$destroy();
    },
    destroy() {
      document.querySelector('.musicbox-setting-wrap').remove();
    },
    handler(promise) {
      promise
        .then(() => {
          this.$message({
            showClose: true,
            message: '设置成功',
            type: 'success'
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: '设置失败',
            type: 'error'
          });
        });
      return promise;
    },
    setScene() {
      this.sceneLoading = true;
      this.handler(
        setScene({ sn: this.sn, deviceType: this.deviceType, currScene: this.model.scene })
      ).finally(() => {
        this.sceneLoading = false;
      });
    },
    setInterval() {
      this.$refs.form.validate().then(res => {
        if (!res) return;
        this.intervalLoading = true;
        this.handler(
          setNotifyInterval({
            sn: this.sn,
            deviceType: this.deviceType,
            currInterval: this.model.interval
          })
        ).finally(() => {
          this.intervalLoading = false;
        });
      });
    },
    setSwitch() {
      this.switchLoading = true;
      this.handler(
        setSwitch({
          sn: this.sn,
          deviceType: this.deviceType,
          currState: this.model.switchers,
          mobileState: +this.model.mobileState
        })
      ).finally(() => {
        this.switchLoading = false;
      });
    },
    setTime() {
      this.dateLoading = true;
      this.handler(
        setTime({ sn: this.sn, deviceType: this.deviceType, currTime: this.model.date })
      ).finally(() => {
        this.dateLoading = false;
      });
    },
    getDeviceInfo() {
      this.getInfoLoading = true;
      getDeviceInfo({ sn: this.sn, deviceType: this.deviceType })
        .then(() => {
          this.$message({
            showClose: true,
            message: '获取成功',
            type: 'success'
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: '获取失败',
            type: 'error'
          });
        })
        .finally(() => {
          this.getInfoLoading = false;
        });
    }
  },
  created() {
    getDeviceStatus({ sn: this.sn, deviceType: this.deviceType, busiType: 3 })
      .then(res => {
        const data = res.data;
        this.model.scene = data.sceneType;
        this.model.date = data.deviceTime;
        this.model.switchers = data.modCtrlState;
        this.model.interval = data.notifyInterval;
        this.model.mobileState = !!data.mobileState;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  beforeDestroy() {
    this.loading = false;
  }
};
</script>

<style lang="scss">
.musicbox-setting-wrap {
  .el-dialog {
    min-width: 700px;
    min-height: 50vh;
    max-width: 80vw;
    width: fit-content;
  }
  .space,
  .item-wrap {
    width: 450px;
    margin-right: 50px;
    display: inline-block;
  }
  .el-checkbox {
    margin-left: 12px;
  }
  .el-input {
    width: 220px;
  }
  .el-form {
    height: 100%;
    width: 750px;
    margin: 0 80px;
  }
}
</style>
